import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const DELETE_QP_MUTATION = gql `
  mutation EP_DeleteQP($qpID: ID!) {
    ep_deleteQP(qpID: $qpID)
  }
`;
export function useDeleteQPMutation(options) {
    return useGQLMutation(DELETE_QP_MUTATION, {
        ...options,
        update(cache, { data }, { variables }) {
            if (data?.ep_deleteQP && variables?.qpID) {
                cache.evict({
                    id: cache.identify({
                        __typename: 'EPQP',
                        id: variables.qpID,
                    }),
                });
            }
        },
    });
}
